import { getDecodedAppInstance } from 'wix-application';
var store = require('store');

export async function getInstance() {
    let instance = await getDecodedAppInstance();
    let formattedInstance = {
        instance: instance,
        appId: instance.appDefId,
        instanceId: instance.instanceId,
        plan: instance.vendorProductId,
        isPremium: instance.vendorProductId != null,
        upgradeUrl: formatUpgradeUrl(instance.appDefId, instance.instanceId),
        reviewUrl: formatReviewUrl(instance.appDefId),
    }
    store.set('instance', formattedInstance)
    return formattedInstance;

}

export async function getSubscription() {
    let instance = await getDecodedAppInstance();
    // console.log("instance", instance);
    return {
        instance: instance,
        appId: instance.appDefId,
        instanceId: instance.instanceId,
        plan: instance.vendorProductId,
        isPremium: instance.vendorProductId != null,
        upgradeUrl: formatUpgradeUrl(instance.appDefId, instance.instanceId),
        reviewUrl: formatReviewUrl(instance.appDefId),
    };
}

export function formatUpgradeUrl(appId, instanceId) {
    return `https://www.wix.com/apps/upgrade/${appId}?appInstanceId=${instanceId}`;
}

export function formatReviewUrl(appId) {
    return `https://www.wix.com/app-market/add-review/${appId}`;
}
